import clsx from 'clsx'
import { Bell, FileText, UserRound } from 'lucide-react'
import { HeaderNotificationsMenu, HeaderUserMenu, ThemeModeSwitcher } from '../../../partials/index'
import { Languages } from '../../../partials/layout/header-menus/Languages'
import { Reports } from '../../../../app/pages/reports/ReportsHistoryWidget'
import FastSwitchOrg from './FastSwitchOrg'
import { FeatureGuard } from '../../../../Utils/featureComponents'
import { useAuthStore } from '../../../../store/authStore'
import { useLang } from '../../../i18n/Metronici18n'

const itemClass = 'ms-1 ms-md-3'
const userAvatarClass = 'symbol-40px'

// Shared trigger: a 40px rounded-square with subtle tint, soft border,
// hover lift + glow. Lucide icon strokes inherit currentColor.
const triggerClass =
  'header-icon-trigger d-flex align-items-center justify-content-center position-relative'

const Navbar = () => {
  const dir = useLang()?.lang.dir || 'ltr'
  const HasNewNotification = useAuthStore(
    (state) => state.user?.has_new_notification
  )
  const isNotification = useAuthStore((state) => state.newNotification)

  return (
    <div className='flex-shrink-0 app-navbar header-icons'>

      <FeatureGuard featureId='header_fast_switch_org'>
        <div className={clsx('app-navbar-item', itemClass)}>
          <FastSwitchOrg btnClass={`${triggerClass} variant-secondary`} />
        </div>
      </FeatureGuard>

      <FeatureGuard featureId='header_notifications'>
        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={`${triggerClass} variant-info`}
            onClick={() => {
              useAuthStore.getState().ChangeNotificationStatus(false)
              useAuthStore.getState().ChangeUserHasNewNotification(false)
            }}
          >
            <Bell size={20} strokeWidth={1.75} />
            {(HasNewNotification || isNotification) && (
              <span className='notification-pulse' />
            )}
          </div>
          <HeaderNotificationsMenu />
        </div>
      </FeatureGuard>

      <FeatureGuard featureId='reports_history'>
        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            id='report'
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom'
            className={`${triggerClass} variant-info`}
          >
            <FileText size={20} strokeWidth={1.75} />
          </div>
          <Reports />
        </div>
      </FeatureGuard>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={`${triggerClass} variant-info`} />
      </div>
      <div className={clsx('app-navbar-item', itemClass)}>
        <Languages toggleBtnClass={`${triggerClass} variant-info`} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol header-avatar-trigger', userAvatarClass)}
          data-kt-menu-trigger="{default: 'hover'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement={dir === 'rtl' ? 'bottom-start' : 'bottom-end'}
        >
          <UserRound size={22} strokeWidth={1.75} />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export { Navbar }
